<template>

    <div id="paywall_tailwind">

        <form @submit.prevent="forms_submit(
            'newsletter_form',
            'We have subscribed you to our newsletter.',
            [
                'name',
                'email',
                'company',
            ]
        )">

            <FormInputField
                class="mb-4"
                placeholder="Navn*"
                type="text"
                :required="true"
                v-model="newsletter_form.name"
            />

            <FormInputField
                class="mb-4"
                placeholder="E-mail*"
                type="text"
                :required="true"
                v-model="newsletter_form.email"
            />

            <FormInputField
                class="mb-4"
                placeholder="Firma"
                type="text"
                :required="false"
                v-model="newsletter_form.company"
            />

            <label class="inline-flex items-center mb-4 cursor-pointer"
                   for="is_terms_accepted">

                <input
                    class="form-checkbox h-5 w-5 text-[#1479FB] focus:outline-none focus:ring-none border border-1 border-[#C1C1C1]"
                    id="is_terms_accepted"
                    type="checkbox"
                    v-model="newsletter_form.is_terms_accepted">

                <p class="ml-2 text-gray-700">

                    Jeg accepterer <a href="/politikker" class="text-[#1479FB]" target="_blank">vilkårene</a>

                </p>

            </label>

            <button class=" hover:bg-white border-2  hover:border-2 w-full font-medium text-white py-4 px-4 text-[20px] leading-tight"
                :class="`bg-${ site.color } border-${ site.color } hover:text-${ site.color }`"
                type="submit">
                Tilmeld Nyhedsbrev
            </button>

        </form>

        <messages
            class="bg-white w-full mt-2"
            :types="['newsletter_form']"
        ></messages>

    </div>

</template>

<script>
import FormInputField from "../components/FormInputField.vue";

export default {

    name: "NewsletterFormView",

    components: {
        FormInputField
    },

    async created() {

        let
            profile_form = await this.get_customer_profile(),
            default_form = this.newsletter_form
        ;

        this.newsletter_form = {
            ...default_form,
            email: profile_form.email,
            name: profile_form.full_name,
            company: profile_form.company_name,
            token: localStorage.getItem('paywall.token'),
            site_id: this.site.id
        };

    },

}
</script>

<style scoped>

</style>
